import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { HelpCircle } from "lucide-react"
import { cn } from "@/lib/utils"

interface InfoTooltipProps {
  text: string
  className?: string
}

export function InfoTooltip({ text, className = "" }: InfoTooltipProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <HelpCircle 
          className={cn(
            "h-3.5 w-3.5 text-muted-foreground/70 hover:text-muted-foreground cursor-help inline-block ml-1", 
            className
          )} 
        />
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-xs text-xs">
        {text}
      </TooltipContent>
    </Tooltip>
  )
}
